export enum Role {
    User = 'User',
    RealtorUser = 'RealtorUser',
    RealtorAdmin = 'RealtorAdmin',
    OsloReadOnly = 'OsloReadOnly',
    OsloReadOnlyLimited = 'OsloReadOnlyLimited',
    OsloUser = 'OsloUser',
    CubitAdmin = 'CubitAdmin',
}
